import React from 'react';


const Videos = () => {
  return(<section className="videoContainer"></section>)};

export default Videos;
